import request from '../utils/request'

// tkb
export function getKtbInfo (params) {
  return request({
    url: '/api/index/tkb-info',
    method: 'get',
    params
  })
}
